/**
 * 日次のまとめに今回の録音が入ったかの判定と、できあがるまでの目安（課題 #174。2026-11-02 高尾さん決定）。
 *
 * BE はまとめに last_recorded_at（入っている最後の録音の時刻）を持たせる。これより新しい録音があれば、
 * そのまとめは「前回の結果」で、今回の結果として出さない。
 *
 * まとめに入るのは解析が済んだ録音だけなので、解析の済んでいない録音は数えない。数えると、
 * 解析できなかった録音が 1 件あるだけで、その日はずっと「前回の結果」のままになる。
 */

interface RecordLike {
  recorded_at?: string | null;
  analysis_json?: unknown;
}

/** last_recorded_at が無いまとめ（BE が入る前に作ったもの）は、見分けられないので false */
export function isPreviousResult(
  lastRecordedAt: string | null | undefined,
  records: readonly RecordLike[]
): boolean {
  if (!lastRecordedAt) return false;
  const included = Date.parse(lastRecordedAt);
  if (Number.isNaN(included)) return false;
  return records.some(
    (r) => r.analysis_json != null && r.recorded_at != null && Date.parse(r.recorded_at) > included
  );
}

/**
 * 待っている間の文言。
 * next_generation_at は「次に作り始める時刻の目安」で、過ぎてもコメントの生成に時間がかかる。
 * 過ぎた後は「あと約 0 分」と言わず、まもなくと伝える。
 */
export function summaryWaitMessage(
  target: string | null,
  nowMs: number,
  tooLong: boolean
): { key: string; params: Record<string, number> } {
  if (tooLong) return { key: 'dashboard.analyzingTakingLong', params: {} };
  const targetMs = target ? Date.parse(target) : Number.NaN;
  if (Number.isNaN(targetMs)) return { key: 'dashboard.analyzingInProgress', params: {} };
  const remainingMs = targetMs - nowMs;
  if (remainingMs <= 0) return { key: 'dashboard.summaryWait.soon', params: {} };
  return { key: 'dashboard.summaryWait.eta', params: { minutes: Math.ceil(remainingMs / 60_000) } };
}
